module.exports = __webpack_public_path__ + "img/tab_icon.65ada8f8.svg";